import React from 'react';

const UsersContext = React.createContext([]);

export default UsersContext
